import { useMemo } from 'react'

import { useRouter } from 'next/router'

import { UUID } from '@/types/Id'

export const useQuerySearchId = () => {
  const router = useRouter()
  const searchId = useMemo(() => {
    if (router.query['search-id']) {
      return router.query['search-id'] as UUID | ''
    }
  }, [router.query])
  return { searchId }
}
